import { lightTheme as theme } from '@zenbusiness/common-components/theme';
import PropTypes from 'prop-types';

import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider as MUIThemeProvider, StyledEngineProvider } from '@mui/material/styles';

function ZenThemeWrapper({ children }) {
  return (
    <MUIThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        <GlobalStyles styles={{
          // Prevent body from scrolling when mobile nav drawer is open.
          'body.drawer-open': { overflow: 'hidden' },
          [theme.breakpoints.up('md')]: {
            'body.drawer-open': { overflow: 'auto' }
          }
        }}
        />
        <CssBaseline />
        { children }
      </StyledEngineProvider>
    </MUIThemeProvider>
  );
}

ZenThemeWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default ZenThemeWrapper;
